/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { MenuItem, ProductListItem, PaginatedProducts } from './types';
import { apiClient } from '@/utils/apiClient';

// GET /data/api/v1/products/menu/?channel=
export const fetchProductMenu = createAsyncThunk<
  MenuItem[],
  { channel?: string },
  { rejectValue: string }
>('products/fetchMenu', async ({ channel }, { rejectWithValue }) => {
  try {
    const qs = channel ? `?channel=${encodeURIComponent(channel)}` : '';
    const resp = await apiClient(`/data/api/v1/products/menu/${qs}`, {
      method: 'GET',
    });
    return resp as MenuItem[];
  } catch (err: any) {
    return rejectWithValue(err.message || 'Failed to load product menu');
  }
});

// GET /data/api/v1/products/?name=&platforms=
export const fetchProducts = createAsyncThunk<
  PaginatedProducts,
  { name?: string; platforms?: string[] },
  { rejectValue: string }
>('products/fetchList', async ({ name, platforms }, { rejectWithValue }) => {
  try {
    const params = new URLSearchParams();
    if (name) params.set('name', name);
    if (platforms) platforms.forEach((p) => params.append('platforms', p));
    const resp = await apiClient(`/data/api/v1/products/?${params}`, {
      method: 'GET',
    });
    return resp as PaginatedProducts;
  } catch (err: any) {
    return rejectWithValue(err.message || 'Failed to load products');
  }
});

// GET sub-products at levels 1–5
export const fetchSubProductsLevel = createAsyncThunk<
  ProductListItem[],
  { level: 1 | 2 | 3 | 4 | 5 },
  { rejectValue: string }
>('products/fetchSubLevel', async ({ level }, { rejectWithValue }) => {
  try {
    const resp = await apiClient(`/data/api/v1/products/level${level}/`, {
      method: 'GET',
    });
    return resp as ProductListItem[];
  } catch (err: any) {
    return rejectWithValue(
      err.message || `Failed to load sub-products level ${level}`
    );
  }
});
